(function () {
  'use strict';

  var root = document.querySelector('[data-pq-cart]');
  var form = document.getElementById('pq-cart-form');
  if (!root || !form) return;

  var codeInput = document.getElementById('cart-discount-code');
  var applyButton = document.getElementById('cart-discount-apply');
  var status = root.querySelector('[data-cart-status]');
  var timer;

  function getCode() {
    return codeInput ? codeInput.value.trim().toUpperCase() : '';
  }

  function saveCode() {
    try { sessionStorage.setItem('pq-discount-code', getCode()); } catch (error) {}
  }

  function cartUrl() {
    var target = '/cart';
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) target += '?preview_theme_id=' + encodeURIComponent(preview);
    return target;
  }

  function discountUrl(target) {
    return '/discount/' + encodeURIComponent(getCode()) + '?redirect=' + encodeURIComponent(target);
  }

  function announce(message) {
    if (status) status.textContent = message;
  }

  function applyDiscount() {
    if (!getCode()) {
      if (codeInput) codeInput.focus();
      announce('Enter a discount code first.');
      return;
    }
    saveCode();
    location.assign(discountUrl(cartUrl()));
  }

  try {
    var stored = sessionStorage.getItem('pq-discount-code');
    if (codeInput && stored) codeInput.value = stored;
  } catch (error) {}

  if (codeInput) {
    codeInput.addEventListener('input', function () {
      codeInput.value = codeInput.value.toUpperCase();
      saveCode();
    });
    codeInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount();
      }
    });
  }

  if (applyButton) applyButton.addEventListener('click', applyDiscount);

  root.addEventListener('click', function (event) {
    var row = event.target.closest('[data-cart-row]');
    if (!row) return;

    var input = row.querySelector('input[type="number"]');
    if (!input) return;

    if (event.target.closest('[data-qty-plus]')) {
      input.value = parseInt(input.value || '0', 10) + 1;
    } else if (event.target.closest('[data-qty-minus]')) {
      input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
    } else {
      return;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  form.querySelectorAll('input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () {
      clearTimeout(timer);
      root.classList.add('is-updating');
      announce('Updating your cart.');
      timer = setTimeout(function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }, 320);
    });
  });

  form.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout' && getCode()) {
      event.preventDefault();
      saveCode();
      location.assign(discountUrl('/checkout'));
      return;
    }

    if (!submitter || submitter.name !== 'checkout') {
      root.classList.add('is-updating');
      announce('Updating your cart.');
    }
  });
})();
